var request = require('./request');
var config = require('./config');
var resolve = require('./resolve');

exports.Get = function(query){
	return request.get(resolve(config.url(), '/alerts'), query).promise();
}
exports.MarkAsRead = function(id){
	return request.del(resolve(config.url(), '/alerts/' + id)).promise();
}
exports.GetTotal = function(){
	return request.get(resolve(config.url(), '/alerts/count')).promise();
}
